
{
  "actions": {
    "save": "Save"
  }
}
